import {ReactNode} from 'react';
import {useTranslation} from 'react-i18next';
import Text from './Text';

interface IProps<T> {
  item: T;
  isSelected: boolean;
  onClickTab: (tab: T) => void;
  beforeElement?: (tab: T) => ReactNode;
  textName: keyof T;
  activeTextClassName: string;
  textClassName: string;
  className?: string;
  needTextTranslation?: boolean;
}

export default function HorizontalTabItem<T>({
  item,
  isSelected,
  onClickTab,
  beforeElement,
  textName,
  activeTextClassName,
  textClassName,
  className,
  needTextTranslation,
}: IProps<T>) {
  const content = item[textName];
  const {t} = useTranslation();
  let children: ReactNode =
    typeof content === 'function'
      ? content(t)
      : typeof content === 'string' && needTextTranslation
        ? t(content)
        : content;
  if (typeof children !== 'object') {
    children = (
      <Text
        className={cn(
          isSelected ? activeTextClassName : textClassName,
          '!whitespace-nowrap'
        )}
      >
        {children}
      </Text>
    );
  }

  return (
    <li
      className={cn(
        'cursor-pointer relative whitespace-nowrap flex-center',
        className
      )}
      onClick={() => onClickTab(item)}
      data-is-selected={isSelected}
    >
      {beforeElement?.(item)}
      {children}
    </li>
  );
}
